import { useSelector } from "react-redux";
import { useEffect, useMemo } from "react";

import { dispatch, getState } from "../../../../state/store";
import {
  setAppsError,
  setIsEmailMessageEditing,
  setIsNeedToResetTextEditorState,
  setOriginalEmailMessage,
  setSelectedApp
} from "../../../../state/ducks";
import { selectAppsError } from "../../../../state/selectors";

import { appsService, appUserService, notificationService, t } from "../../../../services";
import { EditButtonsGroup, WrapperContainer } from "../../../../components";
import { appUserRoles, strCode } from "../../../../consts";
import { responseUtil } from "../../../../utils";

const EmailTabHeaderControl = () => {
  const error = useSelector((store) => store.apps.error);
  const selectedApp = useSelector((store) => store.apps.selectedApp);
  const originalEmailMessage = useSelector((store) => store.apps.originalEmailMessage);
  const isEmailMessageEditing = useSelector((store) => store.apps.isEmailMessageEditing);

  const isReadOnlyAccess = useMemo(() => {
    return !(
      appUserService.hasRole(appUserRoles.Admin) ||
      appUserService.hasRole(appUserRoles.ApplicationManager) ||
      appUserService.hasRole(appUserRoles.ContentManager)
    );
  }, []);

  useEffect(() => {
    if (error) {
      dispatch(setSelectedApp({ ...selectedApp, emailMessage: originalEmailMessage }));
    }
  }, [error]);

  const onHandleEdit = () => {
    dispatch(setIsEmailMessageEditing(true));
  };

  const onHandleCancel = () => {
    dispatch(setAppsError(null));
    dispatch(setSelectedApp({ ...selectedApp, emailMessage: originalEmailMessage }));
    dispatch(setIsEmailMessageEditing(false));
    dispatch(setIsNeedToResetTextEditorState(true));
  };

  const onHandleAccept = async () => {
    dispatch(setAppsError(null));
    const res = await appsService.updateApp({
      appType: selectedApp.appType,
      name: selectedApp?.name,
      emailMessage: selectedApp?.emailMessage
    });

    if (responseUtil.isResponseSuccessful(res)) {
      notificationService.showSuccess({
        title: t(strCode.APP_UPDATED_SHORT_TITLTE),
        message: t(strCode.APP_UPDATED_LONG_TITLTE, { name: selectedApp.name }),
        immediate: false
      });
    }

    const appsError = selectAppsError()(getState());

    if (!appsError) {
      dispatch(setOriginalEmailMessage(selectedApp?.emailMessage));
      dispatch(setIsEmailMessageEditing(false));
    } else {
      dispatch(setAppsError(null));
    }
  };

  return (
    <WrapperContainer mt={-28}>
      {!isReadOnlyAccess && (
        <EditButtonsGroup
          isEdit={!isEmailMessageEditing}
          handleEdit={onHandleEdit}
          handleCancel={onHandleCancel}
          handleAccept={onHandleAccept}
          disableAccept={(selectedApp?.emailMessage || "") === originalEmailMessage}
        />
      )}
    </WrapperContainer>
  );
};

export default EmailTabHeaderControl;
